import { useAtomValue, useSetAtom } from 'jotai';

import { AccordionSection } from '@common/components/AccordionSection';
import {
	FiltersDrawerCheckboxGroup,
	type FiltersDrawerCheckboxGroupItem,
} from '@common/components/FilterGroups/FiltersDrawerCheckboxGroup';

import { useSearchPreorders } from '../../api/useSearchPreorders';
import { modelFilterAtom, preordersBaseParamsAtom, updateModelFilterAtom } from '../../atoms/preordersAtoms';

/**
 * FiltersDrawerVehicleModelSection component that provides vehicle model
 * filtering options from search facets, wrapped in an accordion
 */
export function FiltersDrawerVehicleModelSection() {
	const models = useAtomValue(modelFilterAtom);
	const setModels = useSetAtom(updateModelFilterAtom);

	// Get facet counts from the base query (minimal filters) for unbiased counts
	const baseParams = useAtomValue(preordersBaseParamsAtom);
	const { data: facetData } = useSearchPreorders(baseParams);

	// Extract model facets from search response
	const facets = facetData?.facets as Record<string, Record<string, number>> | undefined;
	const modelCounts = facets?.name ?? {};

	// Build model items with dynamic counts from facets
	const modelItems: FiltersDrawerCheckboxGroupItem[] = Object.entries(modelCounts)
		.map(([model, count]) => ({
			value: model,
			label: model,
			count,
		}))
		.sort((a, b) => a.label.localeCompare(b.label));

	return (
		<AccordionSection title='Vehicle model'>
			<FiltersDrawerCheckboxGroup
				items={modelItems}
				value={models}
				onChange={setModels}
			/>
		</AccordionSection>
	);
}
